import React, { useEffect, useState } from "react";
import { BiUser } from "react-icons/bi";
import { HiMenuAlt3, HiX } from "react-icons/hi";
import Logo from "../../Assets/Svg/mindcareLogo2.svg";

const Navbar = () => {
  const [activeItem, setActiveItem] = useState("Home");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const currentPath = window.location.pathname;
    const activeName = [
      { name: "Home", path: "/" },
      { name: "Service", path: "/services" },
      { name: "Treatment", path: "/treatment" },
      { name: "About", path: "/about" },
      { name: "Contact", path: "/contact" },
    ].find((item) => item.path === currentPath)?.name;

    if (activeName) setActiveItem(activeName);
  }, []);

  const handleItemClick = (name, path) => {
    setActiveItem(name);
    setMenuOpen(false);
    window.location.href = path;
  };

  return (
    <nav className="fixed top-0 left-0 w-full z-20 bg-white/60 dark:bg-card-dark/60 backdrop-blur-sm border-b dark:border-dark px-4 sm:px-6 lg:px-[5%] py-2 shadow">
      <div className="flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <img src={Logo} alt="MindCare Logo" className="w-8 h-8" />
          <h2 className="text-accent font-semibold text-lg">
            <span className="text-2xl font-bold font-serif">M</span>indCare
          </h2>
        </div>

        {/* Desktop Menu */}
        <ul className="hidden md:flex items-center space-x-6">
          {["Home", "Services", "Treatment", "About", "Contact"].map((name) => (
            <li
              key={name}
              onClick={() => handleItemClick(name, `/${name.toLowerCase() === "home" ? "" : name.toLowerCase()}`)}
              className={`cursor-pointer text-primaraytext hover:text-accent transition font-medium ${
                activeItem === name ? "text-accent" : ""
              }`}
            >
              {name}
            </li>
          ))}
        </ul>

        {/* Mobile Actions */}
        <div className="flex items-center gap-3 md:gap-4">
          <div className="border rounded-full bg-white/70 shadow p-2 cursor-pointer">
            <BiUser className="text-accent w-5 h-5" />
          </div>

          {/* Hamburger */}
          <button onClick={() => setMenuOpen(!menuOpen)} className="md:hidden focus:outline-none">
            {menuOpen ? (
              <HiX className="w-6 h-6 text-accent" />
            ) : (
              <HiMenuAlt3 className="w-6 h-6 text-accent" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <ul className="mt-3 space-y-2 px-4 pb-4 md:hidden">
          {["Home", "Services", "Treatment", "About", "Contact"].map((name) => (
            <li
              key={name}
              onClick={() => handleItemClick(name, `/${name.toLowerCase() === "home" ? "" : name.toLowerCase()}`)}
              className={`cursor-pointer py-2 text-primaraytext border-b hover:text-accent transition font-medium ${
                activeItem === name ? "text-accent" : ""
              }`}
            >
              {name}
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default Navbar;

